export enum PatientList {
  AllPatients,
  MyPatients,
}
